import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

const buildSpace = (spaceLink) => {
  return spaceLink.space().then((space) => {
    spaceLink.savedSpace = space;
    return spaceLink;
  });
};

export class SpaceLinkModel extends ModeModelBase {
  override _name = 'spaceLink';
  override idAttribute = 'token';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override attributes = [{ name: 'space_token', default: '' }];
  override hasOne = [{ name: 'space', idAttribute: 'token' }];
}

@Injectable({ providedIn: 'root' })
export class SpaceLinkModelAccessor extends ModelAccessorBase<SpaceLinkModel> {
  override name = 'spaceLink';
  override idAttribute = 'token';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.spaceLink');
  }

  buildSpaceLinksWithAccount(spaceLinks) {
    return this.injectables.$q.all(_.map(spaceLinks, buildSpace));
  }

  createModel(resource, opts?) {
    const model = new SpaceLinkModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
